import React from "react";
import { telefonoParaMostrar } from "../../../helpers/telefonoWhatsapp";
import { WhatsappLink } from "../../components/Whatsapp";
import { plata } from "../../turnos/agenda/agendaLayout";
import {
	cardLabel,
	closeAtLabel,
	ifNotFullLabel,
	kindLabel,
	statusLabel,
	visibilityLabel,
} from "./openMatchModel";

/*
 * "Partido abierto" section of the court reservation detail (Falta un jugador). Presentation only: the
 * reservation row carries the `openMatch` block, and the cancel action (with its confirmation) stays in
 * OrgReservationsScreen, so `onCancel` only asks it to start. Cancelling is offered while the match is not
 * cancelled yet. Each player pays their share at the club, so the price is shown per player.
 */
export default function OpenMatchDetailSection({ openMatch, onCancel }) {
	const players = Array.isArray(openMatch.players) ? openMatch.players : [];
	const price = Number(openMatch.pricePerPlayer) || 0;
	return (
		<section className="zr-openmatch" aria-label="Partido abierto">
			<h4 className="zr-openmatch__title">Partido abierto</h4>
			<dl className="ba-detalle">
				<dt>Estado</dt>
				<dd>{statusLabel(openMatch.status)}</dd>
				<dt>Jugadores</dt>
				<dd>{cardLabel(openMatch)}</dd>
				<dt>Cierre</dt>
				<dd>{closeAtLabel(openMatch.closeAt)}</dd>
				<dt>Tipo</dt>
				<dd>{kindLabel(openMatch.kind)}</dd>
				<dt>Visibilidad</dt>
				<dd>{visibilityLabel(openMatch.visibility)}</dd>
				<dt>Si no se completa</dt>
				<dd>{ifNotFullLabel(openMatch.ifNotFull)}</dd>
				{price > 0 && (
					<>
						<dt>Por jugador</dt>
						<dd>{plata(price)}</dd>
					</>
				)}
			</dl>
			{players.length > 0 && (
				<ul className="zr-openmatch__players">
					{players.map((player, idx) => (
						<li key={`${idx}-${player.name}`} className="zr-openmatch__player">
							<span className="zr-openmatch__player-name">{player.name || "-"}</span>
							{player.isCreator && <span className="zr-badge">Creador</span>}
							{player.isCompanion && <span className="zr-badge">Acompañante</span>}
							{player.phone && (
								<span className="zr-openmatch__player-phone">
									{telefonoParaMostrar(player.phone)}
									<WhatsappLink
										phone={player.phone}
										name={player.name || ""}
										className="odcg-item-wa ba-wa-inline"
									/>
								</span>
							)}
							{player.email && (
								<span className="zr-openmatch__player-email">{player.email}</span>
							)}
						</li>
					))}
				</ul>
			)}
			{onCancel && openMatch.status !== "cancelled" && (
				<button
					type="button"
					className="zr-pill-btn zr-modal__action zr-modal__action--danger"
					onClick={onCancel}
				>
					Cancelar partido
				</button>
			)}
		</section>
	);
}
